const mockData = {
  heroVideo: 'https://customer-assets.emergentagent.com/job_scandi-home-craft/artifacts/9k6icy7a_V1-0001_A013_07031455_C245.mov',
  
  products: [
    {
      id: 1,
      name: 'Essence in Oak',
      description: 'A meditation on material honesty, where solid oak reveals its temporal narrative through grain and gesture',
      image: 'https://customer-assets.emergentagent.com/job_scandi-home-craft/artifacts/4ic7wj25_DSC06750.jpg'
    },
    {
      id: 2,
      name: 'Natural Lineage',
      description: 'Celebrating the inherent poetry of timber—each ring a chronicle, each variation an authentic signature',
      image: 'https://customer-assets.emergentagent.com/job_scandi-home-craft/artifacts/wl61e762_DSC06761.jpg'
    },
    {
      id: 3,
      name: 'Refined Presence',
      description: 'Minimalist articulation rooted in Nordic craft tradition, where restraint becomes eloquence',
      image: 'https://customer-assets.emergentagent.com/job_scandi-home-craft/artifacts/b3tq6ml4_DSC06853.jpg'
    },
    {
      id: 4,
      name: 'Studio Equilibrium',
      description: 'An exploration of balance—functional necessity meeting contemplative form in spatial harmony',
      image: 'https://customer-assets.emergentagent.com/job_scandi-home-craft/artifacts/8y2msi83_DSC06854.jpg'
    }
  ],

  aboutImage: 'https://customer-assets.emergentagent.com/job_scandi-home-craft/artifacts/4s4qrccr_IMG_9848.jpeg',

  values: [
    {
      title: 'Craftsmanship',
      description: 'Each desk is shaped by artisan hands, with decades of woodworking wisdom flowing through every detail and gesture.'
    },
    {
      title: 'Timeless design',
      description: 'Drawing from Scandinavian architectural heritage, we create furniture destined to transcend generations.'
    },
    {
      title: 'Singular expression',
      description: 'No two desks are identical. Natural variation transforms each piece into a unique spatial presence.'
    },
    {
      title: 'Ecological consciousness',
      description: 'We exclusively use certified timber from sustainably managed forests and plant-based finishing treatments.'
    }
  ],

  detailImages: [
    'https://customer-assets.emergentagent.com/job_scandi-home-craft/artifacts/z1ln6hdy_Web%205.jpg',
    'https://customer-assets.emergentagent.com/job_scandi-home-craft/artifacts/snasjxiw_IMG_9786.jpeg'
  ],

  featured: [
    {
      title: 'ESSENCE IN OAK',
      description: 'Drawing from Scandinavian craft lineage, this piece embodies the convergence of temporal elegance with contemporary ergonomic understanding.',
      meta: 'DESIGN | FURNITURE | 2025',
      image: 'https://customer-assets.emergentagent.com/job_scandi-home-craft/artifacts/4ic7wj25_DSC06750.jpg',
      overlay: 'VIEW',
      height: 'tall'
    },
    {
      title: 'REFINED PRESENCE',
      description: 'An investigation of material authenticity and spatial restraint, where detail becomes the carrier of meaning.',
      meta: 'DESIGN | FURNITURE | 2025',
      image: 'https://customer-assets.emergentagent.com/job_scandi-home-craft/artifacts/b3tq6ml4_DSC06853.jpg',
      overlay: null,
      height: 'short'
    },
    {
      title: 'COASTAL MEDITATIONS',
      description: 'Inspired by the liminal spaces of Scandinavian shores, this piece contemplates the dialogue between stillness and transformation.',
      meta: 'DESIGN | OBJECTS | 2025',
      video: 'https://customer-assets.emergentagent.com/job_ac4b2a00-b85e-4dd8-9871-3fae2471a3e5/artifacts/82kdhs5a_Comp%201_3.mp4',
      overlay: null,
      height: 'tall'
    }
  ]
};

export default mockData;